import React from 'react';
import ChatCourseList from './ChatCourseList';
import ChatBankQuotation from './ChatBankQuotation';

interface ChatComponentProps {
  componentName: string;
  data?: any;
  isLoading?: boolean;
}

// 组件注册表
const componentRegistry = {
  chatCourseList: ChatCourseList,
  chatBankQuotation: ChatBankQuotation,
  // 这里可以继续添加其他组件
};

const ChatComponentRenderer: React.FC<ChatComponentProps> = ({ 
  componentName, 
  data, 
  isLoading = false 
}) => {
  // 获取对应的组件
  const Component = componentRegistry[componentName as keyof typeof componentRegistry];
  
  // 如果找不到对应组件，返回默认提示
  if (!Component) {
    return (
      <div style={{
        padding: '16px',
        backgroundColor: 'rgba(255, 193, 7, 0.1)',
        borderRadius: '8px',
        marginTop: '12px',
        border: '1px solid rgba(255, 193, 7, 0.3)',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '14px', color: '#856404' }}>
          未知组件类型: {componentName}
        </div>
      </div>
    );
  }
  
  // 渲染对应组件
  return <Component data={data} isLoading={isLoading} />;
};

export default ChatComponentRenderer; 